import React from "react";
import AdminHeading from "Components/Pages/AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "Components/Pages/AdminPanel/Heading/AdminBreadCrump";
import { useDispatch, useSelector } from "react-redux";
import { useEffect , useRef} from "react";
import {
  a125,
  a128,
  a131,
  a178,
  a18,
  a181,
  a20,
  a33,
  a41,
  a47,
} from "Components/Api/RootApiPath";
import { useState } from "react";
import { InfinitySpin, MagnifyingGlass } from "react-loader-spinner";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { BsHandbag } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { AiOutlineEdit } from "react-icons/ai";
import html2canvas from "html2canvas";


// import "../../PagesStyles/AdminEcommerce.css";
import "../Stockview/AdminEcommerce.css";
import { GenerateLabel } from "Components/Other Functions/GenerateLabel";
import { Grid } from "@mui/material";
import {
  thStyle,
  tdStyle,
  inputStyle,
} from "Components/support/addstock/tableStyles";
import { TableContainer } from "@mui/material";
import GetApiService from "Components/Api/getapiService";
import { useAdminData } from "Components/Pages/AdminPanel/AdminSettings/useAdminData";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import AdminFilters from "./ItemFilter";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoIosPrint } from "react-icons/io";
import "./Filter.css";

import style from "../../../LatestPages/AddNewCustomer.module.css";
import { Icon } from "@iconify/react";
import PageLoader from "Components/PageLoader";

export default function AdminInventory() {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [labelCode, setLabelCode] = useState("");
  const [barCode, setBarCode] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [allCategories, setAllCategories] = useState([]);
  const [productName, setProductName] = useState("");
  const [allProductTypes, setAllProductTypes] = useState([]);
  const [collectionName, setCollectionName] = useState("");
  const [allCollectionTypes, setAllCollectionTypes] = useState([]);
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [selectedItemCodes, setSelectedItemCodes] = useState([]);
  const [deleteSelected, setDeleteSelected] = useState(false);
  const [deleteSelectedButton, setDeleteSelectedButton] = useState(false);
  const [selectBranch, setSelectBranch] = useState("");
  const productsPerPage = 100;

  const [selectedcat, setSelectedcat] = useState("");

  const [loader, setLoader] = useState(false)

  const pdfRef = useRef(null);
  

  const generatePreview = async () => {
    if (!pdfRef.current) return;

    try {
      // Capture the entire div as an image using html2canvas
      const canvas = await html2canvas(pdfRef.current, {
        scale: 2, // High resolution
        useCORS: true, // Allow cross-origin images
        allowTaint: true, // Enable cross-origin images
        windowWidth: pdfRef.current.scrollWidth, // Capture full width
        windowHeight: pdfRef.current.scrollHeight, // Capture full height
      });

      const imgData = canvas.toDataURL("image/png"); // Convert canvas to image data
      setPreviewImage(imgData); // Save image data to state

      // Open the preview in a new window
      const newWindow = window.open("", "_blank");
      newWindow.document.write(
        `<img src="${imgData}" alt="Preview" style="max-width: 100%; height: auto;" />`
      );
    } catch (error) {
      console.error("Error generating preview:", error);
    }
  };

  useEffect(() => {
    // Ensure all images inside the div are fully loaded
    const images = pdfRef.current?.querySelectorAll("img");
    let loadedCount = 0;

    if (images) {
      images.forEach((img) => {
        if (img.complete) {
          loadedCount++;
        } else {
          img.onload = () => {
            loadedCount++;
            if (loadedCount === images.length) {
              setIsLoaded(true);
            }
          };
        }
      });
    }
  }, []);

  const generatePdf = async () => {
    if (!pdfRef.current) return;
    setLoader(true)

    try {
      // **STEP 1: Scroll entire div into view to ensure images load**
      pdfRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

      // **STEP 2: Wait for 1 second to let off-screen images load**
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // **STEP 3: Capture the full div including off-screen images**
      const canvas = await html2canvas(pdfRef.current, {
        scale: 2, // High quality
        useCORS: true, // Allow external images
        allowTaint: true, // Allow cross-origin images
        logging: true, // Enable logging for debugging
        windowWidth: document.documentElement.scrollWidth, // Capture full width
        windowHeight: document.documentElement.scrollHeight, // Capture full height
      });

      // Convert to image
      const imgData = canvas.toDataURL("image/png");

      // Get dynamic component size
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Create PDF dynamically sized to the content
      const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]);
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("full-content.pdf");
      setLoader(false)

    } catch (error) {
      setLoader(false)
      console.error("Error generating PDF:", error);
    }
  };


  //   const columns = [

  //     { key: "serialNumber", label: "S.No", type: "read", priority: 1 },
  //     { key: "CategoryName", label: "Category", type: "read", priority: 2 },
  //     { key: "ProductName", label: "Product", type: "read", priority: 3 },
  //     { key: "DesignName", label: "Design", type: "read", priority: 4 },
  //     { key: "SKU", label: "SKU", type: "read", priority: 5 },
  //     { key: "ItemCode", label: "Item Code", type: "read", priority: 6 },
  //     { key: "RFIDCode", label: "Rfid Code", type: "read", priority: 7 },
  //     { key: "GrossWt", label: "Gross Wt", type: "read", priority: 8 },

  //     { key: "ClipWeight", label: "Clip WT", type: "read", priority: 9 },
  //     { key: "NetWt", label: "Net Wt", type: "read", priority: 10 },
  //     { key: "MRP", label: "Mrp", type: "read", priority: 11 },
  //     { key: "PacketName", label: "Packet", type: "read", priority: 12 },
  //     { key: "BoxName", label: "Box Name", type: "read", priority: 13 },
  //     { key: "VendorName", label: "Vendor", type: "read", priority: 14 },
  //     { key: "BranchName", label: "Branch", type: "read", priority: 15 },
  //     { key: "Action", label: "Action", type: "action", priority: 16 },

  //   ];

  const columns = [
    {
      key: "serialNumber",
      label: "S.No",
      type: "read",
      priority: 1,
      customWidth: "20px",
    },
    {
      key: "CategoryName",
      label: "Category",
      type: "read",
      priority: 2,
      customWidth: "80px",
    },
    {
      key: "ProductName",
      label: "Product",
      type: "read",
      priority: 3,
      customWidth: "112px",
    },
    {
      key: "DesignName",
      label: "Design",
      type: "read",
      priority: 4,
      customWidth: "108px",
    },
    {
      key: "SKU",
      label: "SKU",
      type: "read",
      priority: 5,
      customWidth: "65px",
    },
    {
      key: "ItemCode",
      label: "Item Code",
      type: "read",
      priority: 6,
      customWidth: "65px",
    },
    {
      key: "RFIDCode",
      label: "Rfid Code",
      type: "read",
      priority: 7,
      customWidth: "65px",
    },
    {
      key: "GrossWt",
      label: "Gross Wt",
      type: "read",
      priority: 8,
      customWidth: "65px",
    },
    {
      key: "TotalStoneWeight",
      label: "Stone Wt",
      type: "read",
      priority: 10,
      customWidth: "65px",
    },
    
    {
      key: "NetWt",
      label: "Net Wt",
      type: "read",
      priority: 10,
      customWidth: "65px",
    },
    {
      key: "TotalStoneAmount",
      label: "Stone Amt",
      type: "read",
      priority: 11,
      customWidth: "65px",
    },
    {
      key: "MakingPercentage",
      label: "Making%",
      type: "read",
      priority: 11,
      customWidth: "65px",
    },
    {
      key: "MRP",
      label: "Mrp",
      type: "read",
      priority: 11,
      customWidth: "65px",
    },
    {
      key: "MakingFixedWastage",
      label: "Fixed Wastage",
      type: "read",
      priority: 12,
      customWidth: "65px",
    },
    {
      key: "MakingFixedAmt",
      label: "Fixed Amt",
      type: "read",
      priority: 12,
      customWidth: "65px",
    },
    {
      key: "ClipWeight",
      label: "Clip WT",
      type: "read",
      priority: 13,
      customWidth: "65px",
    },
    
    {
      key: "PacketName",
      label: "Packet",
      type: "read",
      priority: 12,
      customWidth: "65px",
    },
    {
      key: "BoxName",
      label: "Box Name",
      type: "read",
      priority: 13,
      customWidth: "65px",
    },
    {
      key: "VendorName",
      label: "Vendor",
      type: "read",
      priority: 14,
      customWidth: "100px",
    },
    {
      key: "BranchName",
      label: "Branch",
      type: "read",
      priority: 15,
      customWidth: "65px",
    },
    {
      key: "Action",
      label: "Action",
      type: "action",
      priority: 16,
      customWidth: "65px",
    },
  ];

  const [errorMessage, setErrorMessage] = useState(null);
  const [showModal, setShowModal] = useState(false); // Modal visibility state

  const [view, setView] = useState("List");

  const sortedColumns = columns.sort((a, b) => a.priority - b.priority);

  const navigate = useNavigate();

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const dbname = adminLoggedIn.Clients.OrganisationName;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  // const clientCode = adminLoggedIn.ClientCode;
  // const employeeCode = adminLoggedIn.EmployeeCode;
  // const labelFormat = parseInt(adminLoggedIn.LabelFormat);
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);

  const {
    clientCode,
    CompanyId,
    CounterId,
    BranchId,
    EmployeId,
    employeeCode,
    rdPurchaseFormat,
  } = useAdminData();

  const apiService = new GetApiService(clientCode);

  const loadData = async () => {
    setLoading(true);
    try {
      const apiCalls = [
        apiService.fetchAllCategories(),
        apiService.fetchAllProductType(),
        apiService.fetchAllDesigns(),
        apiService.fetchAllLabelledStock()
        // apiService.fetchAllLabelledStockNew(),
      ];

      const results = await Promise.allSettled(apiCalls);

      console.log("results", results);

      console.log("view", view);

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          // Handle successful response
          switch (index) {
            case 0:
              setAllCategories(result.value);
              break;
            case 1:
              setAllProductTypes(result.value);
              break;
            case 2:
              setAllCollectionTypes(result.value);
              break;
            case 3:
              let data = result.value;
              console.log("check all data", data);
              let branchProducts = data;
              console.log(branchProducts, "branchProducts");
              // Add a serial number property to each product
              if (selectBranch === "Home" || selectBranch === "Branch 2") {
                branchProducts = data.filter(
                  (x) => x.BranchName === selectBranch
                );
              } else {
                branchProducts = data;
              }

              console.log("branchProducts", branchProducts);

              const activeProducts = branchProducts.filter(
                (product) => product.Status === "Active"
              );

              console.log("check all active", activeProducts);

              // Add a serial number property to each product
              const productsWithSerial = activeProducts.map(
                (product, index) => ({
                  ...product,
                  serialNumber: index + 1,
                })
              );

              setAllProducts(productsWithSerial.reverse());

              //   setAllProducts(data.data);
              setDeleteSelected(false);
              console.log(productsWithSerial, "productsWithSerial");
              break;

            default:
              break;
          }
        } else {
          if (index + 1 > 1) {
            console.error(
              `Error loading data for API ${index + 1}:`,
              result.reason
            );
            handleError(
              `Failed to load data for API ${index + 1}: ${result.reason}`
            );
          }
        }
      });
    } catch (error) {
      console.error("Error loading data:", error);
      handleError("Error loading data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [clientCode]);

  const handleError = (message) => {
    setErrorMessage(message);
    setShowModal(true); // Open the modal
  };
  const reloadData = () => {
    setShowModal(false); // Close the modal
    loadData(); // Reload data
  };

  const fetchCategories = () => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((response) => {
        setAllCategories(response);
      });
  };

  useEffect(() => {
    // fetchCategories();
  }, []);
  const fetchProductTypes = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((response) => {
        setAllProductTypes(response);
      });
  };

  useEffect(() => {
    // fetchProductTypes();
  }, []);
  const fetchCollectonData = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    await fetch(a131, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((response) => {
        setAllCollectionTypes(response);
      });
  };

  useEffect(() => {
    // fetchCollectonData();
  }, []);

  let Entryby_Staff_id = parseInt(adminLoggedIn);

  const fetchAllProducts = async () => {
    // setLoading(true);
    const formData = {
      ClientCode: clientCode,
    };
    try {
      const response = await fetch(a181, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      console.log("check all data", data);
      let branchProducts = data;
      console.log(branchProducts, "branchProducts");
      // Add a serial number property to each product
      if (selectBranch === "Home" || selectBranch === "Branch 2") {
        branchProducts = data.filter((x) => x.BranchName === selectBranch);
      } else {
        branchProducts = data;
      }

      const activeProducts = branchProducts.filter(
        (product) => product.Status === "Active"
      );

      // Add a serial number property to each product
      const productsWithSerial = activeProducts.map((product, index) => ({
        ...product,
        serialNumber: index + 1,
      }));

      // const productsWithSerial = branchProducts.map((product, index) => ({
      //     ...product,
      //     serialNumber: index + 1,
      // }));

      // setAllProducts(productsWithSerial.reverse()); // Assuming data.data is an array of products
      setAllProducts(productsWithSerial.reverse());
      //   setAllProducts(data.data);
      setDeleteSelected(false);
      console.log(productsWithSerial, "productsWithSerial");
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false); // Make sure to set loading to false even on error
    }
  };
  //   const productsData = useSelector((state) => state.reducer7.products);
  // console.log("Fetched Products:", productsData);
  //   useEffect(() => {
  //     setAllProducts(productsData);
  //   }, [allProducts]);
  useEffect(() => {
    // setLoading(true);
    window.scrollTo(0, 0);
    // fetchAllProducts();
    // fetchData();
  }, []);
  useEffect(() => {
    if (Entryby_Staff_id == 1) {
      setSelectBranch("Home");
    } else if (Entryby_Staff_id == 2) {
      setSelectBranch("Branch2");
    }
  }, []);
  // console.log(allProducts);
  // console.log(allProducts);
  // useEffect(() => {}, [currentPage]);

  // const indexOfLastProduct = currentPage * productsPerPage;
  // const indexOfFirstProduct = indexOfLastProduct - productsPerPage;


  // const filteredData = searchInput
  //   ? currentProducts?.filter((items) =>
  //       Object.values(items)?.some(
  //         (value) =>
  //           typeof value === "string" &&
  //           value.toLowerCase().includes(searchInput.toLowerCase())
  //       )
  //     )
  //   : currentProducts;

  //   console.log(currentProducts );

 




 // Step 1: Always paginate first (default 100 items per page)
const indexOfLastProduct = currentPage * productsPerPage;
const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
const paginatedProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

// const currentProducts = filteredProducts.slice(
//   indexOfFirstProduct,
//   indexOfLastProduct
// );

// Step 2: Search across all data (not just paginated items)
const searchedProducts = searchInput
  ? filteredProducts.filter((item) =>
      Object.values(item).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchInput.toLowerCase())
      )
    )
  : filteredProducts; // If no search, keep full data


  // Step 3: Apply pagination AFTER search
const currentProducts = searchInput
? searchedProducts.slice(0, productsPerPage) // Keep only first 100 results after search
: paginatedProducts; // Default pagination

  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
    console.log("nextClick");
  };

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
    console.log("prevClick");
  };
  const handleCheckboxChange = (productId, categoryid) => {
    if (productId === "all") {
      // Select/deselect all checkboxes
      setSelectAll(!selectAll);
      setSelectedProducts(selectAll ? [] : allProducts.map((x) => x.Id));
    } else {
      // Check if the product is already selected
      const isSelected = selectedProducts.includes(productId);

      // If the product is already selected, remove it from the list
      if (isSelected) {
        setSelectedProducts((prevSelected) =>
          prevSelected.filter((Id) => Id !== productId)
        );
      } else {
        if (selectedcat === "") {
          setSelectedcat(categoryid);

          // If the product is not selected, add it to the list
          setSelectedProducts((prevSelected) => [...prevSelected, productId]);
        } else {
          if (parseInt(selectedcat) !== parseInt(categoryid)) {
            alert("Cannot select products from different categories.");
            return;
          }

          // If the product is not selected, add it to the list
          setSelectedProducts((prevSelected) => [...prevSelected, productId]);
        }
      }
    }
  };

  const handleCheckboxChangeold1 = (productId, categoryId) => {
    console.log("checking categoryid ", categoryId);

    if (productId === "all") {
      // Select/deselect all checkboxes only if all products belong to the same category
      const categories = new Set(
        allProducts.map((product) => product.categoryId)
      );
      if (categories.size > 1) {
        alert("Cannot select products from different categories.");
        return;
      }
      setSelectAll(!selectAll);
      setSelectedProducts(selectAll ? [] : allProducts.map((x) => x.Id));
    } else {
      // Check if the product is already selected
      const isSelected = selectedProducts.includes(productId);

      if (isSelected) {
        // Remove the product from the selected list
        setSelectedProducts((prevSelected) =>
          prevSelected.filter((Id) => Id !== productId)
        );
      } else {
        const selectedCategories = new Set(
          selectedProducts.map(
            (Id) => allProducts.find((product) => product.Id === Id)?.categoryId
          )
        );

        // Add current category if there are no selected products yet
        if (selectedCategories.size === 0) {
          selectedCategories.add(categoryId);
        }

        // Ensure all selected categories match the current category
        if (
          selectedCategories.size > 0 &&
          !selectedCategories.has(categoryId)
        ) {
          alert("Cannot select products from different categories.");
          return;
        }

        // Add the product to the selected list
        setSelectedProducts((prevSelected) => [...prevSelected, productId]);
      }
    }
  };

  const handleCheckboxChange1 = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) {
        // If product is already selected, remove it
        return prevSelected.filter((id) => id !== productId);
      } else {
        // Otherwise, add the product to the selected list
        return [...prevSelected, productId];
      }
    });
  };

  const printAll = () => {
    const selectedProductData = allProducts.filter((x) =>
      selectedProducts.includes(x.Id)
    );
    printPDF(selectedProductData);
    console.log("button", selectedProductData);
  };
  console.log('labelFormat', labelFormat);
  
  // Skkhandre New design
  const printPDF = async (products) => {
    await GenerateLabel(products, labelFormat);
  };

  const printList = () => {
    let selectedProductData;
    if (selectedProducts.length === 0) {
      selectedProductData = currentProducts;
    } else {
      selectedProductData = currentProducts.filter((x) =>
        selectedProducts.includes(x.Id)
      );
    }

    printListAll(selectedProductData);
  };

  const printListAll = async (data) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const startX = 10; // Adjusted startX value for the serial number column
    let startY = 20;
    const lineHeight = 5;
    const margin = 5;
    const serialNumberWidth = 20; // Width for the serial number column
    const columnWidth =
      (pageWidth - startX - serialNumberWidth - 10 * margin) / 10;

    doc.setFont("helvetica", "normal");
    // doc.setFontSize(12);
    doc.setFontSize(8);

    const generateHeader = () => {
      doc.text("S. No.", startX, startY); // Serial Number
      doc.text("Design Name", startX + columnWidth, startY);
      doc.text("SKU", startX + 3 * columnWidth, startY);
      doc.text("Gross Wt", startX + 4.2 * columnWidth, startY);
      doc.text("Net Wt", startX + 5.3 * columnWidth, startY);
      doc.text("Item Code", startX + 6.5 * columnWidth, startY);
      doc.text("Barcode No", startX + 8 * columnWidth, startY);
      // doc.text("M Fixed Amt", startX + 7 * columnWidth, startY);
      // doc.text("M Fix Wastage", startX + 8.5 * columnWidth, startY);
      // doc.text("M Percentage", startX + 10 * columnWidth, startY);
      // doc.text("M per_gram", startX + 11.5 * columnWidth, startY);
      // doc.text("stoneAmount", startX + 13 * columnWidth, startY);
      doc.text("Tid", startX + 9.5 * columnWidth, startY);
    };
    const totalNetWt = data.reduce(
      (total, item) => total + (parseFloat(item.netWt) || 0),
      0
    );
    const totalGrossWt = data.reduce(
      (total, item) => total + (parseFloat(item.grosswt) || 0),
      0
    );
    // Generate header on the first page
    generateHeader();
    // doc.text(
    //     `Total Net Wt: ${totalNetWt.toFixed(3)} gm`,
    //     startX + 5 * columnWidth,
    //     startY - 10
    // );
    // doc.text(
    //     `Total Gross Wt: ${totalGrossWt.toFixed(3)} gm`,
    //     startX,
    //     startY - 10
    // );
    // Generate data rows

    let y = startY + lineHeight + margin;
    data.forEach((item, index) => {
      // Check if we need to start a new page
      if (index > 0 && y + lineHeight > pageHeight - margin) {
        doc.addPage();
        startY = 20; // Reset startY for the new page
        // Generate header on each new page
        generateHeader();
        y = startY + lineHeight + margin; // Update y position for the new page
      }

      const serialNumber = index + 1;
      doc.text(serialNumber.toString(), startX, y);
      doc.text(
        item.DesignName ? item.DesignName.toString().substr(0, 8) : "N/A",
        startX + columnWidth,
        y
      );
      doc.text(
        item.SKU ? item.SKU.toString() : "N/A",
        startX + 3 * columnWidth,
        y
      );
      doc.text(
        item.GrossWt ? item.GrossWt.toString() : "N/A",
        startX + 4.2 * columnWidth,
        y
      );
      doc.text(
        item.NetWt ? item.NetWt.toString() : "N/A",
        startX + 5.3 * columnWidth,
        y
      );
      doc.text(
        item.ItemCode ? item.ItemCode.toString() : "N/A",
        startX + 6.5 * columnWidth,
        y
      );
      // doc.text(
      //   item.making_Fixed_Amt ? item.making_Fixed_Amt.toString() : "N/A",
      //   startX + 7 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.making_Fixed_Wastage
      //     ? item.making_Fixed_Wastage.toString()
      //     : "N/A",
      //   startX + 8.5 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.making_Percentage ? item.making_Percentage.toString() : "N/A",
      //   startX + 10 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.making_per_gram ? item.making_per_gram.toString() : "N/A",
      //   startX + 11.5 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.stoneAmount ? item.stoneAmount.toString() : "N/A",
      //   startX + 13 * columnWidth,
      //   y
      // );
      doc.text(
        item.BranchName ? item.BranchName.toString() : "N/A",
        startX + 8 * columnWidth,
        y
      );
      doc.text(
        item.TIDNumber ? item.TIDNumber.toString() : "N/A",
        startX + 9.5 * columnWidth,
        y
      );
      y += lineHeight + margin;
    });

    // Add page numbers
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.text(`Page ${i} of ${totalPages}`, pageWidth - 50, pageHeight - 10);
    }

    // Get PDF data as Uint8Array
    const pdfData = doc.output();

    // Create a new Blob from the PDF data
    const pdfBlob = new Blob([pdfData], { type: "application/pdf" });

    // Create a URL from the Blob
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfUrl, "_blank");
  };

  const filterOrders = () => {
    let filtered = allProducts;

    if (labelCode !== "") {
      filtered = filtered.filter(
        (product) => product.ItemCode && product.ItemCode.includes(labelCode)
      );
    }
    if (barCode !== "") {
      filtered = filtered.filter(
        (product) => product.RFIDCode && product.RFIDCode.includes(barCode)
      );
    }

    console.log("allProducts", allProducts);

    if (categoryName == "") {
      // setCategoryName(""),
      setProductName(""),
        setCollectionName(""),
        setFilteredProducts(allProducts);
      // console.log("categoryName", categoryName);
    }

    if (categoryName !== "") {
      filtered = filtered.filter(
        (product) =>
          product.CategoryName &&
          product.CategoryName.includes(categoryNameSelected)
      );
    }
    if (productName !== "") {
      console.log("filteredProductsTypes1", filtered);
      filtered = filtered.filter(
        (product) =>
          // product.itemType && product.itemType.includes(productNameSelected)
          product.ProductId && product.ProductId === productTypeIdSelected
      );
      console.log("filteredProductsTypes2", filtered);
    }
    if (collectionName !== "") {
      filtered = filtered.filter(
        (product) =>
          product.DesignName &&
          product.DesignName.includes(collectionNameSelected)
      );
    }

    if (fromDate !== "" && toDate !== "") {
      filtered = filtered.filter((product) => {
        const createdDate = new Date(product.CreatedOn);
        return (
          createdDate >= new Date(fromDate) && createdDate <= new Date(toDate)
        );
      });
    }

    setFilteredProducts(filtered);
    setCurrentPage(1); // Reset to the first page after filtering
  };
  console.log("Filtered", filteredProducts);
  useEffect(() => {
    filterOrders();
    window.scrollTo(0, 0);
    // console.log("filtered", filteredProducts);
    // console.log("ptype", allProductTypes);
  }, [
    categoryName,
    productName,
    collectionName,
    labelCode,
    barCode,
    allProducts,
    fromDate,
    toDate,
  ]);
  let categoryId = parseInt(categoryName.split(",")[0]);
  let categoryNameSelected = categoryName.split(",")[1];
  const filteredProductTypes = allProductTypes.filter(
    (product) => product.CategoryId == categoryId
  );
  let productNameSelected = productName.split(",")[1];
  let productTypeIdSelected = parseInt(productName.split(",")[0]);
  let collectionNameSelected = collectionName.split(",")[1];
  const filteredCollection = allCollectionTypes.filter(
    (product) => product.ProductId == productTypeIdSelected
  );
  console.log("current", currentProducts);

  // const filteredCollection = collectionTypeData.filter(
  //   (product) => product.productType == productTypeName
  // );
  // console.log(filteredProducts);
  const handleDeleteCheckboxChange = (productId, itemCode) => {
    let updatedCheckedProducts = [...checkedProducts];
    let updatedSelectedItemCodes = [...selectedItemCodes];

    if (updatedCheckedProducts.includes(productId)) {
      updatedCheckedProducts = updatedCheckedProducts.filter(
        (id) => id !== productId
      );
      updatedSelectedItemCodes = updatedSelectedItemCodes.filter(
        (code) => code !== itemCode
      );
    } else {
      updatedCheckedProducts.push(productId);
      updatedSelectedItemCodes.push(itemCode);
    }

    if (updatedCheckedProducts.length > 0) {
      setDeleteSelectedButton(true);
    } else {
      setDeleteSelectedButton(false);
    }

    setCheckedProducts(updatedCheckedProducts);
    setSelectedItemCodes(updatedSelectedItemCodes);
  };
  const selectedItems = selectedItemCodes.map((itemCode) => ({
    ItemCode: itemCode,
  }));

  const deleteAllProducts = async (itemsToDelete) => {
    const deletAllItemsList = itemsToDelete.map((x) => {
      return { ...x, ClientCode: clientCode };
    });
    try {
      const response = await fetch(a178, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(deletAllItemsList),
      });

      const rcvdData = await response.json();
      console.log("AllItemsDeleted", rcvdData);
      console.log("Response:", rcvdData);
      // if (rcvdData.status == "Success") {
      // Deletion was successful
      // console.log("Item deleted successfully:", response.message);
      // alert(rcvdData.Message);
      setSelectedItemCodes([]);
      setCheckedProducts([]);
      fetchAllProducts();
      // You can show an alert or notification here
      // alert(data.message);

      setDeleteSelectedButton(false);
      // } else {
      // Handle the case where deletion failed
      // console.error("Failed to delete item:", response.Message);

      // You can show an error message to the user
      // alert("Failed to delete item: " + response.Message);
      // }
    } catch (error) {
      // Handle any network or fetch API errors
      console.error("An error occurred:", error);

      // Show an error message to the user
      // alert("An error occurred while deleting the item.");
    }
  };
  console.log("productName", productName);

  const handlefilter = (filteredItems) => {
    setFilteredProducts(filteredItems); // Update filtered products in the parent state
  };

  // const bulkprint = () => {
  //   const selectedProductData = allProducts.filter((x) =>
  //     selectedProducts.includes(x.Id)
  //   );
  //   printPDF(selectedProductData);
  //   console.log("selected products   ", selectedProductData);
  // };

  const bulkprint = () => {
    const selectedProductData = allProducts.filter((x) =>
      selectedProducts.includes(x.Id)
    );
  
    if (selectedProductData.length === 0) {
      console.log("No products selected for printing.");
      alert('Check the item you want to print')
      return; // Exit the function if no products are selected
    }
  
    printPDF(selectedProductData);
    console.log("Selected products:", selectedProductData);
  };

  const filteredData = searchInput
    ? currentProducts?.filter((items) =>
        Object.values(items)?.some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchInput.toLowerCase())
        )
      )
    : currentProducts;

    console.log(filteredData);
    




 

  return (
    <div>
      <AdminHeading />

      {loading ? (
        // Show spinner while loading
        <div className="spinner-container">
          {/* <ClipLoader size={50} color={"#123abc"} loading={loading} /> */}
          {/* <p>Loading data...</p> */}
          <PageLoader />
        </div>
      ) : (
        <div>
          <ErrorModal
            isOpen={showModal}
            onRequestClose={() => {
              setShowModal(false); // Close the modal
              navigate("/adminhome"); // Redirect to /adminhome
            }}
            onReload={reloadData} // Pass reload function
            message={errorMessage}
          />
          {
            loader && <PageLoader/>
          }
          <div style={{ paddingTop: "130px" }}>
            <AdminBreadCrump
              title={"Inventory"}
              companyName={"Loyalstring"}
              module={"E-commerce"}
              page={"Inventory"}
            />

            <div
              style={{ padding: "0px 16px" }}
              className="adminAddCategoryMainBox"
            >
              <div className="adminAddCategoryInnerBoxFT">
                {!loading == true ? (
                  <div className="table-containerLL">
                    <div
                      style={{
                        width: "100%",
                        justifyContent: "left",
                        flexWrap: "wrap",
                      }}
                      className="adminAllProductsFilterBox"
                    >
                      <AdminFilters
                        allProducts={allProducts}
                        handlefilter={handlefilter}
                        bulkprint={bulkprint}
                        searchInput={searchInput}
                        setSearchInput={setSearchInput}
                        view={view}
                        setView={setView}
                        printList={printList}
                        generatePdf={generatePdf}
                        generatePreview={generatePreview}
                      />
                    </div>

                    <div
                    ref={pdfRef}
                      style={{
                        overflowX: "auto",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#657484 #e0e0e0",
                        width: "100%",
                      }}
                    >
                      {view === "List" ? (
                        <table
                          size="small"
                          style={{
                            borderRadius: "4px",
                            borderCollapse: "collapse",
                            borderSpacing: "0",
                          }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#627383",
                              color: "#FFFFFF",
                            }}
                          >
                            <tr>
                              {sortedColumns.map((column) => (
                                <th
                                  key={column.key}
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    textAlign: "center",
                                    backgroundColor: "#627383",
                                    color: "#fff",
                                    fontSize: "12px",
                                    fontWeight: "normal",
                                    minWidth: column.customWidth,
                                    ...(column.key === "Action" && {
                                      position: "sticky", // Additional styles for the Action column
                                      right: 0,
                                      zIndex: 2, // Ensures the header stays above other content
                                    }),
                                  }}
                                >
                                  {column.label}
                                </th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {currentProducts.map((product, idx) => (
                              <tr
                                key={product.Id}
                                style={{ borderBottom: "1px solid #ccc" }}
                              >
                                {sortedColumns.map((column) => (
                                  <td
                                    key={column.key}
                                    style={{
                                      padding: "2px 5px",
                                      border: "1px solid #ccc",
                                      textAlign: "center",
                                      fontSize: "12px",

                                      backgroundColor:
                                        idx % 2 === 0 ? "#fff" : "#eeeeee", // Alternate row colors
                                      ...(column.key === "Action" && {
                                        fontSize: "12px",
                                        position: "sticky",
                                        right: 0,

                                        zIndex: 1,
                                      }), // Apply custom style only to Action column
                                    }}
                                  >
                                    {column.type === "checkbox" ? (
                                      <input
                                        style={{ fontSize: "12px" }}
                                        type="checkbox"
                                        checked={
                                          selectAll ||
                                          selectedProducts.includes(product.Id)
                                        }
                                        onChange={() =>
                                          handleCheckboxChange(
                                            product.Id,
                                            product.CategoryId
                                          )
                                        }
                                      />
                                    ) : column.type === "action" ? (
                                      <div
                                        style={{ display: "flex", gap: "10px" }}
                                      >
                                        {/* Example Actions */}
                                        <Icon
                                          onClick={() => {
                                            navigate("/bulk_product_edit", {
                                              state: {
                                                selectedProducts:
                                                  selectedProducts.length > 0
                                                    ? selectedProducts
                                                    : [product],
                                              },
                                            });
                                          }}
                                          style={{
                                            color: "#627383",
                                            cursor: "pointer",
                                          }}
                                          icon="material-symbols-light:edit-outline"
                                          width="24"
                                          height="24"
                                        />
                                        <Icon
                                          onClick={() => {
                                            setDeleteSelected(!deleteSelected),
                                              setSelectedItemCodes([]),
                                              setCheckedProducts([]),
                                              setDeleteSelectedButton(false);
                                          }}
                                          style={{
                                            color: "#627383",
                                            cursor: "pointer",
                                          }}
                                          icon="weui:delete-filled"
                                          width="20"
                                          height="20"
                                        />
                                        <Icon
                                        onClick={()=> bulkprint()}
                                          // onClick={() => {
                                          //   const selectedProductData =
                                          //     allProducts.filter(
                                          //       (x) =>
                                          //         product.Id === parseInt(x.Id)
                                          //     );
                                          //   printPDF(selectedProductData);
                                          // }}
                                          style={{
                                            fontSize: "24px ",
                                            color: "#627383",
                                          }}
                                          icon="ic:outline-print"
                                        />
                                        <input
                                          type="checkbox"
                                          style={{
                                            padding: "5px",
                                            color: "#000",
                                            height: "17px",
                                            width: "17px",
                                          }}
                                          size={"1.5rem"}
                                          checked={selectedProducts.includes(
                                            product.Id
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange1(product.Id)
                                          }
                                        />
                                      </div>
                                    ) : column.type === "read" ? (
                                      column.label === "Design1" ? (
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "blue",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            navigate(
                                              `/product_details?productId=${product.Id}`
                                            );
                                          }}
                                        >
                                          {column.calculate
                                            ? column.calculate(product)
                                            : product[column.key]}
                                        </span>
                                      ) : (
                                        <span style={{ fontSize: "12px" }}>
                                          {column.calculate
                                            ? column.calculate(product)
                                            : product[column.key]}
                                        </span>
                                      )
                                    ) : null}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                     

                        <div className="grid-container">
                          {filteredData.map((product, idx) => {

                            console.log(product);
                            
                            // Split the comma-separated images into an array
                            const imageArray = product.Images
                              ? product.Images.split(",")
                              : [];

                            return (
                              <div className="grid-tile" key={product.Id}>
                                {/* Image Section */}
                                <div className="image-container">
                                  {/* {imageArray.length > 0 ? (
                                    imageArray.map((img, i) => (
                                      <img
                                    
                                        key={i}
                                        src={`https://testing.loyalstring.co.in/${dbname}/ProductImage/${img}`}
                                        alt={`${product.Product} Image ${
                                          i + 1
                                        }`}
                                        className="product-image"
                                        // crossOrigin="use-credentials"  
                                      />
                                 
                                    ))
                                  ) : (
                                    <img
                                      src="https://via.placeholder.com/100" // Fallback image if no images exist
                                      alt="Placeholder"
                                      className="product-image"
                                    />
                                  )} */}

                                  {imageArray.length > 0 ? (
                                    <img
                                      src={`https://testing.loyalstring.co.in/${dbname}/ProductImage/${imageArray[0]}`} // First image only
                                      alt={`${product.Product} Image 1`}
                                      className="product-image"
                                    />
                                  ) : (
                                    <img
                                      src="https://via.placeholder.com/100" // Fallback image if no images exist
                                      alt="Placeholder"
                                      className="product-image"
                                    />
)}

                                </div>

                               
                              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                             <div>
                             <p className="pLL"><strong>Gross:</strong> {product.GrossWt}</p>
                             <p className="pLL">
                                  <strong>SKU:</strong> {product.SKU}
                                </p>
                           
                             </div>
                             <div>
                            
                                <p className="pLL">
                                  <strong>Item Code:</strong> {product.ItemCode}
                                  <p className="pLL"> <strong>RFID:</strong> {product.RFIDCode}</p>
                                </p>
                             </div>
                              </div>
                              
                               
                               
                               

                                {/* <div className="tile-actions">
                                  <button
                                    style={{
                                      backgroundColor: "#0077d4",
                                      width: "20%",
                                    }}
                                    onClick={() =>
                                      console.log("Edit", product.Id)
                                    }
                                  >
                                    <Icon
                                      onClick={() => handleEditData(product)}
                                      style={{
                                        color: "#fff",
                                        cursor: "pointer",
                                      }}
                                      icon="material-symbols-light:edit-outline"
                                      width="20"
                                      height="20"
                                    />
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#0077d4",
                                      width: "20%",
                                    }}
                                    onClick={() =>
                                      console.log("Delete", product.Id)
                                    }
                                  >
                                    <Icon
                                      style={{
                                        color: "#fff",
                                        cursor: "pointer",
                                      }}
                                      icon="weui:delete-filled"
                                      width="20"
                                      height="20"
                                    />
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#0077d4",
                                      width: "20%",
                                    }}
                                    onClick={() =>
                                      console.log("Print", product.Id)
                                    }
                                  >
                                    <Icon
                                      style={{
                                        color: "#fff",
                                        cursor: "pointer",
                                      }}
                                      icon="ic:outline-print"
                                      width="20"
                                      height="20"
                                    />
                                  </button>
                                </div> */}
                              </div>
                            );
                          })}
                        </div>
                      )}
                      
                    </div>
                  </div>
                ) : null}

                {/* Pagination controls */}
                <div className="bulkProductAddingTableMain">
                  <button
                    style={{ backgroundColor: "#0077d4", color: "#fff" }}
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <button
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    style={{ backgroundColor: "#0077d4", color: "#fff" }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="adminInventoryMobilePrintButtonsBox">
                        <button onClick={printAll}>Print</button>
                        <button onClick={printList}>Print List</button>

                        <button
                            onClick={() => {
                                setSelectedProducts([]),
                                    setSelectAll(false),
                                    setCategoryName(""),
                                    setProductName(""),
                                    setCollectionName(""),
                                    setFromDate(""),
                                    setToDate(""),
                                    setFilteredProducts(allProducts);
                            }}
                        >
                            Reset
                        </button>
                        {deleteSelectedButton ? (
                            <button
                                onClick={() => deleteAllProducts(selectedItems)}
                                style={{ backgroundColor: "#c14456", color: "white" }}
                            >
                                Delete Selected
                            </button>
                        ) : null}
                    </div> */}
        </div>
      )}
    </div>
  );
}
